import React, { FC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import Label10Font from '../../../Theme/Fonts/Label10'
import LabelFont from '../../../Theme/Fonts/Label'

export type BetButtonProps = {
    /**
     * optional text on the left in smaller grey font
     * */
    label?: string
    /**
     * text on the right if there is a label, text in the center if there is not
     * */
    value: string
    /**
     * callback when component gets pressed
     * @TJS-type function
     * */
    onPress?: () => void
} & TestID

const BetButton: FC<BetButtonProps> = ({ label, value, onPress, testID }) => {
    const component = (
        <Grid horizontal centerVertical borderRadius={2} paddingX={3} backgroundColor="pearl-2">
            {label ? (
                <Grid minWidth={0} flexShrink={1}>
                    <Label10Font textAlign="left" color="keshi-3" numberOfLines={1}>
                        {label}
                    </Label10Font>
                </Grid>
            ) : null}
            <Grid noExpand={!!label} flexShrink={0}>
                <LabelFont textAlign={label ? 'right' : 'center'} numberOfLines={1}>
                    {value}
                </LabelFont>
            </Grid>
        </Grid>
    )
    return (
        <Grid noExpand height={22} testID={testID}>
            {onPress ? (
                <Touchable onPress={onPress} expand>
                    {component}
                </Touchable>
            ) : (
                component
            )}
        </Grid>
    )
}

export default memo(BetButton)
